import { Link } from '@reach/router'
import { Accordion, AccordionItem } from 'components/accordion'
import Resource from 'components/global/Resource'
import { Button } from '@arckit/ui'
import { Col, Row } from 'components/grid'
import OverlayVideo from 'components/overlay-video'
import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import SchoolResultsSlider from 'components/digital-solutions/SchoolResultsSlider'
import { P } from 'components/typography/Paragraph'

// import { Carousel } from 'react-responsive-carousel'
// import westwardExpansion from 'images/arc-core/westward-expansion.jpg'
// import contemporaryIssues from 'images/arc-core/contemporary-issues.jpg'
interface Props {
	standard?: 'CCSS' | 'TEKS'
	showSupports?: boolean
	language?: 'english' | 'spanish'
	grade?: 'K' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12'
}

const TransformYourClassroom = ({ standard = 'CCSS', showSupports = true, language = 'english', grade = '5' }: Props) => {
	return (
		<Row overflow={false} id="curriculum">
			<Col>
				<Tabs selectedTabClassName="text-ab-100 border-ab-100">
					<TabList className="mb-6 flex flex-wrap">
						<Tab data-cy="year-button" className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-lg">
							{language === 'english' ? 'What Does a Year Look Like?' : 'Visión general del año'}
						</Tab>
						<Tab data-cy="day-button" className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-lg">
							{language === 'english' ? 'What Does a Day Look Like?' : 'Visión general de un día'}
						</Tab>
						{/* ! Removing the Equity Tab Temporarily */}
						{/* <Tab className="mx-4 mb-6 text-base lg:text-lg shadow-sm flex-grow text-center border px-3 py-5 rounded cursor-pointer">Excellence & Equity for All</Tab> */}
						{showSupports && (
							<Tab data-cy="supports-button" className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-lg">
								Blended & Digital Supports
							</Tab>
						)}
						<Tab className="mx-4 mb-6 flex-grow cursor-pointer rounded border px-3 py-5 text-center text-base lg:text-lg">Results</Tab>
					</TabList>

					<TabPanel>
						<Row>
							<Col className="flex flex-col items-center">
								{standard === 'TEKS' ? (
									language === 'english' ? (
										<Resource data-cy="year-document-english-teks" title="What Does a Year Look Like? (TEKS)" shadow noZoom />
									) : (
										<Resource data-cy="year-document-spanish-teks" title="What Does a Year Look Like? (Spanish) (TEKS)" shadow noZoom />
									)
								) : language === 'english' ? (
									<Resource data-cy="year-document-english" title={`What Does a Year Look Like? | Grade ${grade}`} shadow noZoom />
								) : (
									<Resource data-cy="year-document-spanish" title="What Does a Year Look Like? (Spanish)" shadow noZoom />
								)}
								<p>Click to Download as a PDF</p>
							</Col>
						</Row>
					</TabPanel>
					<TabPanel>
						<Row>
							<Col className="flex flex-col items-center">
								{standard === 'TEKS' ? (
									language === 'english' ? (
										<Resource data-cy="day-document-english-teks" title="What Does a Day Look Like? (TEKS)" shadow noZoom />
									) : (
										<Resource data-cy="day-document-spanish-teks" title="What Does a Day Look Like? (Spanish) (TEKS)" shadow noZoom />
									)
								) : language === 'english' ? (
									<Resource data-cy="day-document-english" title="What Does a Day Look Like?" shadow noZoom />
								) : (
									<Resource data-cy="day-document-spanish" title="What Does a Day Look Like? (Spanish)" shadow noZoom />
								)}
								<p>Click to Download as a PDF</p>
							</Col>
						</Row>
					</TabPanel>
					{/* ! Removing the Equity Tab Temporarily */}
					{/* <TabPanel>
						<div>
							<span className="w-full text-left sm:text-center block text-ab-100 mx-auto text-3xl sm:text-4xl mb-2 max-w-xl">
								A Curriculum Designed to Ensure Success for ALL Students
							</span>
							<div className="py-4 px-0 sm:px-8">
								<Row>
									<Col>
										<Carousel showThumbs={false} showStatus={false} infiniteLoop>
											<div>
												<p className="text-slate-400 text-lg text-left sm:text-center max-w-4xl mx-auto leading-loose">
													Shifting the educational experience from knowledge transmission to apprenticeship and inquiry, ARC Core prepares students not
													only for college and careers but also for taking their places as responsible citizens in a democracy. Starting in elementary
													school, students analyze sources and think critically about author bias and reliability in order to become change agents in
													their communities.
												</p>
												<img src={contemporaryIssues} alt="Intentional Intersectionality" />
											</div>
											<div>
												<p className="text-slate-400 text-lg text-left sm:text-center max-w-4xl mx-auto leading-loose">
													ARC Core’s thematic units are both intentionally multicultural and intersectional in their approach to cultures, identities, and
													communities. Texts present multiple perspectives and traditionally underrepresented narratives that are scientifically and
													historically accurate, informative, and engaging. Diverse texts are not add-ons, they are essential to students' development of
													knowledge and skills within the curriculum. The curriculum asks students to analyze both texts and history through
													interconnected lenses as they build knowledge within and across themes through authentic, rigorous tasks.
												</p>
												<img src={westwardExpansion} alt="A Critical Approach to Texts" />
											</div>
											<div>
												<p className="text-slate-400 text-lg text-left sm:text-center max-w-3xl mx-auto leading-loose">
													ARC Core’s approach to data-driven continuous improvement uses curriculum as a lever for excellence and equity.
												</p>
												<Row center>
													<Col width="w-full md:w-1/2" className="mb-4">
														<Resource title="5 Touchstones for Excellence and Equity" shadow maxHeight={600} />
														<br></br>
														<br></br>
														<a href="https://www.americanreading.com/documents/educating-males-of-color.pdf" target="_blank" rel="noopener noreferrer">
															Read the Full White Paper
														</a>
													</Col>
												</Row>
											</div>
										</Carousel>
									</Col>
								</Row>
							</div>
						</div>
					</TabPanel> */}
					{showSupports && (
						<TabPanel>
							<div className="px-4">
								<Accordion>
									<AccordionItem titleTestId="pl-accordion-item-title" openByDefault title="Professional Learning" top>
										<P data-cy="pl-copy" className="mx-auto max-w-3xl text-center">
											American Reading Company offers virtual professional learning that equips teachers and leaders to meet the changing needs of learners
											across platforms.
										</P>
										<Row className="py-4" center>
											<Col width="w-full xl:w-7/12">
												<Row>
													<Col width="w-1/2" className="py-4">
														<Resource textTestId="virtual-pl-resource-text" title="Virtual PL" shadow text="Virtual PL" />
													</Col>
													{/* <Col width="w-1/2 sm:w-1/3" className="py-4">
														<Resource textTestId="arc-u-resource-text" title="ARC University" shadow text="ARC University®" />
													</Col> */}
													<Col width="w-1/2" className="py-4">
														<Resource textTestId="llpl-resource-text" title="Leadership Learning PL" shadow text="Leadership Learning PL" />
													</Col>
												</Row>
											</Col>
										</Row>
										<Row center>
											<Col width="w-full xl:w-7/12" className="mb-5">
												<OverlayVideo title="Leadership Learning Series Promo" />
											</Col>
										</Row>
									</AccordionItem>
									<AccordionItem titleTestId="digital-supports-accordion-item-title" title="Digital Supports">
										<Row className="py-4">
											<P className="mx-auto mb-5 max-w-3xl text-center">
												ARC Core digital supports, including interactive digital frameworks, thematic eLibraries, and sample prerecorded lessons or
												Read-Alouds, are available with a SchoolPace subscription.
											</P>
											<Col width="w-full md:w-1/2" className="mb-6 md:mb-0">
												<img src="/images/arc-core/schoolpace-connect-screenshot.png" alt="schoolpace connect screenshot" />
											</Col>
											<Col width="w-full md:w-1/2" className="mb-6 flex items-center md:mb-0">
												<img src="/images/arc-core/thematic-elibrary.png" alt="elibraries" />
											</Col>
											<Col>
												<div className="border-4 border-dashed border-ab-100 p-2 sm:p-5">
													<Row className="items-center">
														<Col width="w-full md:w-1/3" className="mb-3 sm:mb-0">
															<img src="/images/logos/schoolpace-connect-logo.svg" alt="schoolpace connect logo" />
														</Col>
														<Col width="w-full md:w-2/3" className="pl-4 sm:pl-6">
															<span className="mb-3 inline-block text-lg font-semibold sm:text-xl">
																An enhanced platform for ELA content delivery, providing access to:
															</span>
															<ul className="list-disc pl-2 text-lg text-gray-500 sm:pl-6">
																<li>
																	Digital Foundational Skills Toolkits<sup>®</sup> with sample prerecorded lessons (Y&#8211;2R/A&#8211;2R)
																</li>
																<li>Wide Reading eLibraries (Y&#8211;Pu/A&#8211;Pú)</li>
																{/* <li>
																	ARC Adventures
																	<sup>®</sup>
																</li> */}
																<li>ARC Core digital supports for select themes and grades</li>
															</ul>
															<div className="mb-4 mt-6 flex md:mb-0 md:mt-0 md:justify-end">
																<Link to="/digital-solutions">
																	<Button label="Learn More" />
																</Link>
															</div>
														</Col>
													</Row>
												</div>
											</Col>
										</Row>
									</AccordionItem>
									{/* <AccordionItem title="Classroom Modules Packaged for Social Distancing">
										<Row>
											<p className="mb-5 text-slate-400 text-lg text-center max-w-3xl mx-auto">
												We now offer ARC Core modules packaged to support instruction when students can't share books in the classroom. These modules
												include traditional Core Texts for shared reading and Lab Notebooks with daily student-facing reading and writing activities.
											</p>
											<Col width="w-full md:w-1/2" className="my-6">
												<span className="inline-block w-full mb-3 text-center text-lg sm:text-xl">Teacher Materials</span>
												<img src={socialDistance1} alt="social distance module" className="border-dashed border-4 border-ab-100" />
											</Col>
											<Col width="w-full md:w-1/2" className="my-6">
												<span className="inline-block w-full mb-3 text-center text-lg sm:text-xl">Student Materials</span>
												<img src={socialDistance2} alt="social distance module" className="border-dashed border-4 border-ab-100" />
											</Col>
										</Row>
									</AccordionItem> */}
									<AccordionItem titleTestId="add-ons-accordion-item-title" title="Add-On Packages" bottom>
										<Row>
											<P className="mx-auto mb-5 max-w-3xl text-center">
												If you've already purchased traditional ARC Core modules, we offer add-on packages to support blended and at-home learning.
											</P>
											<Col width="w-full md:w-1/2" className="my-6">
												<P shade="darkest" className="mb-3 text-center font-semibold">
													Class Set of Shared Reading Texts & Notebooks
												</P>
												<img src="/images/arc-core/add-on-packages-1.png" alt="social distance module" className="border-4 border-dashed border-ab-100" />
											</Col>
											<Col width="w-full md:w-1/2" className="my-6">
												<P shade="darkest" className="mb-3 text-center font-semibold">
													Class Set of Notebooks Only
												</P>
												<img src="/images/arc-core/add-on-packages-2.png" alt="social distance module" className="border-4 border-dashed border-ab-100" />
											</Col>
										</Row>
									</AccordionItem>
								</Accordion>
							</div>
						</TabPanel>
					)}

					<TabPanel>
						<Row>
							<Col>
								<SchoolResultsSlider />
							</Col>
						</Row>
					</TabPanel>
				</Tabs>
			</Col>
		</Row>
	)
}

export default TransformYourClassroom
